import { ContainerWithSidebarCards, SidebarCardData } from '../../Common/ContainerWithSidebarCards';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { InvoiceStatus } from '@cyberlabrs/helpers';
import { useHttpGetInvoicesOnMount } from '../../../hooks';

export interface FormValues {
    search: string;
    statuses: InvoiceStatus[];
}

export const InvoiceList = () => {
    const [selectedInvoice, setSelectedInvoice] = useState<SidebarCardData>({
        id: '',
        number: '',
        clientName: '',
        status: InvoiceStatus.DRAFT,
        total: 0,
        fileUrl: '',
        s3name: '',
    });

    const [queries, setQueries] = useState<FormValues>({
        search: '',
        statuses: [],
    });

    const initialInvoice = useLocation().state?.invoice;

    useEffect(() => {
        if (initialInvoice) {
            setSelectedInvoice(initialInvoice);
        }
    }, [initialInvoice]);

    const { data, loadMore, isLoading, hasMore, refetch } = useHttpGetInvoicesOnMount({
        mode: 'infinite',
        size: 16,
        search: queries.search || undefined,
        statuses: queries.statuses.length > 0 ? queries.statuses : undefined,
    });

    const elements: SidebarCardData[] = data.map(invoice => ({
        id: invoice.id,
        number: invoice.number,
        clientName: invoice.clientName,
        status: invoice.status,
        total: invoice.total,
        fileUrl: invoice.fileUrl,
        s3name: invoice.s3name,
    }));

    useEffect(() => {
        refetch();
    }, [queries]);

    return (
        <div className="invoice-list">
            <div className="invoice-list__content">
                <ContainerWithSidebarCards
                    loadMore={loadMore}
                    hasMore={hasMore}
                    isLoading={isLoading}
                    elements={elements}
                    setSelectedInvoice={setSelectedInvoice}
                    selectedInvoice={selectedInvoice}
                    setQueries={setQueries}
                />
            </div>
        </div>
    );
};
